import React from "react";
import { useCallback, useState, useEffect, useRef } from "react";
import styles from "./index.module.scss";
import useForm from "../Form/hooks/useForm";
import debounce from "lodash.debounce";
import { useRouter } from "next/router";

export default function Input(props) {
  const { className = "" } = props;
  const [onChange, formData] = useForm();
  const search = true;
  const value = formData[props.name];
  const [change, setChange] = useState(value);
  const changeHandler = (e) => {
    if (e.target.value.length >= 3 || e.target.value.length === 0) {
      onChange(
        e.target.value.length === 0 ? [] : e.target.value,
        props,
        search
      );
    }
  };

  const debouncedChangeHandler = useCallback(debounce(changeHandler, 300), []);

  return (
    <div className={styles.root}>
      <input
        {...props}
        value={change}
        className={`${className} ${styles.input}`}
        onChange={(e) => {
          debouncedChangeHandler(e);
          setChange(e.target.value);
        }}
      />
    </div>
  );
}
